import { lastDayOfMonth, format } from "date-fns";
import { BsFillCloudDownloadFill, BsCloudCheckFill, BsCloudMinusFill } from "react-icons/bs";
import { colors } from "../../utils/colors";
import { useContext, useState } from "react";
import { helpers } from "../../utils/helpers";
import { ClipLoader } from "react-spinners";
import { DownloadDocProps } from "../../utils/types";
import { UserContext } from "../../context/user-context/userContext";
import * as R from "ramda";

export const DownloadDoc = (props: DownloadDocProps) => {
    const { month } = props;
    const lastMonth = format(lastDayOfMonth(month), "MMM d, y");

    // CONTEXT
    const userContext = useContext(UserContext);
    const { userId } = userContext;

    // STATES
    const [loading, setLoading] = useState<boolean>(false);
    const [downloaded, setDownloaded] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const download = async () => {
        setLoading(true);
        const userAgent = navigator.userAgent;

        console.log(userAgent);
        setTimeout(async () => {
            const id = !R.includes("Chrome", userAgent)
                ? `${helpers.RandomNumber(100, 999)}-${helpers.RandomNumber(100, 999)}-000`
                : `${helpers.RandomNumber(100, 999)}-${helpers.RandomNumber(100, 999)}-${helpers.RandomNumber(
                      100,
                      999
                  )}`;

            const downloaded = await helpers.getDocument(month.toString(), userId.toString(), id);
            if (downloaded) {
                setDownloaded(true);
                setError(false);
            } else {
                setDownloaded(false);
                setError(true);
            }

            setLoading(false);
        }, 2000);
    };

    return (
        <div className="most-recent-doc-container">
            <p>
                <b>{format(month, "MMMM")} Statement</b>
            </p>

            <p>Adv Plus Banking - 1111</p>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingTop: "60px"
                }}
            >
                <p style={{ color: colors.darkGray }}>{lastMonth}</p>

                {!loading && !downloaded && !error && (
                    <button className="download-button" onClick={() => download()}>
                        <BsFillCloudDownloadFill size={25} />
                    </button>
                )}

                {!loading && downloaded && (
                    <button className="download-button download-success" onClick={() => download()}>
                        <BsCloudCheckFill size={25} color={colors.lightGreen} />
                    </button>
                )}

                {!loading && !downloaded && error && (
                    <button className="download-button download-fail" onClick={() => download()}>
                        <BsCloudMinusFill size={25} color={colors.red} />
                    </button>
                )}

                {loading && <ClipLoader size={25} color={colors.darkPurple} />}
            </div>
        </div>
    );
};
